export default __webpack_public_path__ + "static/flag-ee-788732da863ee216898ceba2d9584fe2.svg";